import * as Types from '__generated__/types';

import { gql } from '@apollo/client';
export type IntercompanyObjectFragment = { __typename?: 'IntercompanyObject', id: string, role?: Types.RoleEnum | null, relationType?: Types.RelationEnum | null, foreignObjectId?: string | null, foreignObjectType: string, foreignRegion: string, foreignDealId?: string | null, foreignRole?: Types.RoleEnum | null, foreignObjectNumber?: string | null, archivedAt?: string | null };

export const IntercompanyObjectFragmentDoc = gql`
    fragment intercompanyObject on IntercompanyObject {
  id
  role
  relationType
  foreignObjectId
  foreignObjectType
  foreignRegion
  foreignDealId
  foreignRole
  foreignObjectNumber
  archivedAt
}
    `;